<template>
  <div class="booth-page-container">
    <!-- 面包屑导航 -->
    <el-page-header @back="goBack" content="展位管理"></el-page-header>

    <el-card class="box-card" shadow="hover">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="custom-tabs">
        <!-- 展位列表 -->
        <el-tab-pane label="展位列表" name="list">
          <div class="table-toolbar">
            <div class="left-group">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="addNewBooth">
                新增展位
              </el-button>
              <el-button icon="el-icon-download"   size="small"  @click="exportBooths">
                导出数据
              </el-button>
            </div>
            <div class="right-group">
              <span class="stats-info">
                总计：{{ boothList.length }} 个展位
              </span>
            </div>
          </div>

          <el-table
            :data="boothList"
            border
            size="mini"
            style="width: 100%"
            stripe
            header-cell-class-name="table-header"
          >
            <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
            <el-table-column prop="name" label="展位名称" width="90"></el-table-column>
            <el-table-column label="所属展会" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.expo_title || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="所属场馆" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.venue_title || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="订购商家" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.order_shop_title || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="订购时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.order_time | dateFormat }}
              </template>
            </el-table-column>
            <el-table-column label="预定状态" width="100" align="center">
              <template slot-scope="scope">
                <span class="status-tag yes" v-if="scope.row.order_shop_title">
                  <i class="el-icon-check"></i>已预定
                </span>
                <span class="status-tag no" v-else>
                  <i class="el-icon-close"></i>未预定
                </span>
              </template>
            </el-table-column>
            <el-table-column label="支付信息" width="90" align="center">
              <template slot-scope="scope">
                <span
                  class="pay-info"
                  v-if="scope.row.order_shop_title"
                >
                  已支付
                </span>
              </template>
            </el-table-column>
            <el-table-column label="业务员" width="90" align="center">
              <template slot-scope="scope">-{{ scope.row.serller?scope.row.serller.name_cn:'' }}</template>
            </el-table-column>
            <el-table-column prop="category_name" label="分类" width="90"></el-table-column>
            <el-table-column prop="type" label="类型" width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.type === 1 ? 'primary' : 'success'">
                  {{ scope.row.type === 1 ? '整个展位' : '半个展位' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" width="90" align="right">
              <template slot-scope="scope">
                <span class="price-text">¥{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="area" label="面积" width="80" align="center">
              <template slot-scope="scope">
                {{ scope.row.area }}㎡
              </template>
            </el-table-column>
            <el-table-column   fixed="right" label="操作" width="160" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  plain
                  icon="el-icon-edit"
                  @click="editBooth(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  plain
                  icon="el-icon-delete"
                  @click="deleteBooth(scope.row.id)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 展位编辑 -->
        <el-tab-pane label="展位编辑" name="edit">
          <div class="form-wrapper">
            <el-form
              :inline="false"
              :model="currentBooth"
              :rules="rules"
              ref="formRef"
              label-width="110px"
              autocomplete="on"
              size="small"
              class="ali-pay-form"
            >
              <div class="form-section">
                <div class="section-title">
                  <i class="el-icon-info"></i>基础信息
                </div>
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="展位名称" prop="name">
                      <el-input
                        placeholder="请输入展位名称"
                        v-model="currentBooth.name"
                        class="input-style"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="所属展馆" prop="hall_id">
                      <el-select
                        v-model="currentBooth.hall_id"
                        placeholder="请选择展馆"
                        @change="handleHallChange"
                        class="select-style"
                      >
                        <el-option
                          v-for="item in hallList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="展位分类" prop="category_id">
                      <el-select
                        v-model="currentBooth.category_id"
                        placeholder="请选择分类"
                        class="select-style"
                      >
                        <el-option
                          v-for="item in categoryList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="展位类型" prop="type">
                      <el-radio-group v-model="currentBooth.type" class="radio-group">
                        <el-radio :label="1">整个展位</el-radio>
                        <el-radio :label="2">半个展位</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="价格(元)" prop="price">
                      <el-input
                        v-model="currentBooth.price"
                       
                        class="number-style"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="面积(㎡)" prop="area">
                      <el-input
                        v-model="currentBooth.area"
                    
                
                       
                        class="number-style"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="总金额(元)" prop="price">
                      <el-input-number
                        v-model="currentBooth.amount"
                        :min="0"
                        :precision="2"
                        :step="100"
                        class="number-style"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>

              </div>

              <div class="form-section">
                <div class="section-title">
                  <i class="el-icon-map-marker"></i>展位位置布局
                </div>
                <el-row>
                  <el-col>
                    <el-form-item label="坐标设置">
                      <div class="layout-container">
                        <div class="form-container">
                          <el-row :gutter="20">
                            <el-col :span="12">
                              <el-form-item label="左上角X">
                                <el-input-number
                                  v-model="currentBooth.top_left_x"
                                  :min="0"
                                  :max="1000"
                                  controls-position="right"
                                  @change="updatePositionDisplay"
                                ></el-input-number>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="左上角Y">
                                <el-input-number
                                  v-model="currentBooth.top_left_y"
                                  :min="0"
                                  :max="1000"
                                  controls-position="right"
                                  @change="updatePositionDisplay"
                                ></el-input-number>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="12">
                              <el-form-item label="右上角X">
                                <el-input-number
                                  v-model="currentBooth.top_right_x"
                                  :min="0"
                                  :max="1000"
                                  controls-position="right"
                                  @change="updatePositionDisplay"
                                ></el-input-number>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="右上角Y">
                                <el-input-number
                                  v-model="currentBooth.top_right_y"
                                  :min="0"
                                  :max="1000"
                                  controls-position="right"
                                  @change="updatePositionDisplay"
                                ></el-input-number>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="12">
                              <el-form-item label="右下角X">
                                <el-input-number
                                  v-model="currentBooth.bottom_right_x"
                                  :min="0"
                                  :max="1000"
                                  controls-position="right"
                                  @change="updatePositionDisplay"
                                ></el-input-number>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="右下角Y">
                                <el-input-number
                                  v-model="currentBooth.bottom_right_y"
                                  :min="0"
                                  :max="1000"
                                  controls-position="right"
                                  @change="updatePositionDisplay"
                                ></el-input-number>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="12">
                              <el-form-item label="左下角X">
                                <el-input-number
                                  v-model="currentBooth.bottom_left_x"
                                  :min="0"
                                  :max="1000"
                                  controls-position="right"
                                  @change="updatePositionDisplay"
                                ></el-input-number>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="左下角Y">
                                <el-input-number
                                  v-model="currentBooth.bottom_left_y"
                                  :min="0"
                                  :max="1000"
                                  controls-position="right"
                                  @change="updatePositionDisplay"
                                ></el-input-number>
                              </el-form-item>
                            </el-col>
                          </el-row>

                          <div class="tool-buttons">
                            <el-button
                              type="primary"
                              size="small"
                              @click="startPointSelection"
                            >
                              {{ isSelectingPoints ? '结束选点' : '开始选点' }}
                            </el-button>
                            <el-button size="small" @click="clearCoordinates">
                              清空坐标
                            </el-button>
                            <el-button size="small" @click="autoDetectBooths">
                              自动识别
                            </el-button>
                            <el-upload
                              action="#"
                              :show-file-list="false"
                              :before-upload="beforeMapUpload"
                              :on-change="handleMapUpload"
                              :auto-upload="false"
                              accept=".png,.jpg,.jpeg,.webp,.svg"
                              class="upload-btn"
                            >
                              <el-button size="small">上传地图</el-button>
                            </el-upload>
                          </div>
                        </div>

                        <div class="map-container">
                          <div class="map-header">
                            <span class="map-title">展馆布局图</span>
                            <div class="map-controls">
                              <el-button
                                size="mini"
                                @click="zoomOut"
                                :disabled="isLocked"
                              >
                                缩小
                              </el-button>
                              <el-button
                                size="mini"
                                @click="zoomIn"
                                :disabled="isLocked"
                              >
                                放大
                              </el-button>
                              <el-button size="mini" @click="resetView">
                                重置
                              </el-button>
                              <el-button
                                size="mini"
                                :type="isLocked ? 'success' : ''"
                                @click="toggleLock"
                              >
                                {{ isLocked ? '已锁定' : '锁定视图' }}
                              </el-button>
                              <span class="zoom-display">
                                {{ Math.round(scale * 100) }}%
                              </span>
                            </div>
                          </div>
                          <div
                            class="map-canvas"
                            ref="mapCanvas"
                            @click="handleMapClick"
                            @mousemove="handleMouseMove"
                            @mousedown="handleMouseDown"
                          >
                            <canvas
                              ref="canvas"
                              :width="canvasWidth"
                              :height="canvasHeight"
                            ></canvas>
                          </div>

                          <div class="coordinates-display">
                            <div class="coordinate-item">
                              <span>鼠标位置：</span>
                              <span v-if="mousePosition">
                                ({{ mousePosition.x }}, {{ mousePosition.y }})
                              </span>
                              <span v-else>未检测</span>
                            </div>
                            <div class="coordinate-item">
                              <span>选择状态：</span>
                              <el-tag
                                :type="isSelectingPoints ? 'success' : 'info'"
                                size="mini"
                              >
                                {{ isSelectingPoints ? '选点中' : '浏览中' }}
                              </el-tag>
                            </div>
                            <div class="coordinate-item">
                              <span>视图状态：</span>
                              <el-tag
                                :type="isLocked ? 'success' : 'warning'"
                                size="mini"
                              >
                                {{ isLocked ? '已锁定' : '可缩放' }}
                              </el-tag>
                            </div>
                            <div
                              class="coordinate-item"
                              v-if="selectedPoints.length > 0"
                            >
                              <span>已选点：</span>
                              <el-tag
                                v-for="(point, index) in selectedPoints"
                                :key="index"
                                size="mini"
                                style="margin-right: 3px"
                              >
                                {{ index + 1 }}
                              </el-tag>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="form-section">
                <div class="section-title">
                  <i class="el-icon-picture"></i>其他信息
                </div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="展位图片">
                      <el-upload
                        class="upload-demo"
                        action="#"
                        :on-change="handleImageUpload"
                        :auto-upload="false"
                        :show-file-list="false"
                      >
                        <el-button size="small" type="primary">
                          点击上传
                        </el-button>
                        <div slot="tip" class="tip-text">
                          支持 jpg/png，≤500KB
                        </div>
                      </el-upload>
                      <div
                        v-if="currentBooth.image_url"
                        class="image-preview"
                      >
                        <el-image
                          :src="currentBooth.image_url"
                          fit="contain"
                        ></el-image>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="展位描述">
                      <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入展位描述"
                        v-model="currentBooth.description"
                        class="textarea-style"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="form-button-group">
                <el-button type="primary" @click="submitForm">
                  <i class="el-icon-check"></i>保存展位
                </el-button>
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="activeTab = 'list'">返回列表</el-button>
              </div>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 展位信息弹窗 -->
    <el-dialog
      :title="selectedBoothInfo ? selectedBoothInfo.name : '展位信息'"
      :visible.sync="showBoothInfoDialog"
      width="550px"
      class="info-dialog"
    >
      <div v-if="selectedBoothInfo" class="dialog-body">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="展位名称">
            {{ selectedBoothInfo.name }}
          </el-descriptions-item>
          <el-descriptions-item label="所属展馆">
            {{ selectedBoothInfo.hall_name }}
          </el-descriptions-item>
          <el-descriptions-item label="分类">
            {{ selectedBoothInfo.category_name }}
          </el-descriptions-item>
          <el-descriptions-item label="类型">
            <el-tag
              :type="selectedBoothInfo.type === 1 ? 'primary' : 'success'"
            >
              {{ selectedBoothInfo.type === 1 ? '整个展位' : '半个展位' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="价格">
            <span class="dialog-price">¥{{ selectedBoothInfo.price }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="面积">
            {{ selectedBoothInfo.area }}㎡
          </el-descriptions-item>
          <el-descriptions-item label="描述" :span="2">
            {{ selectedBoothInfo.description || '暂无描述' }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="coord-box">
          <div class="coord-title">展位坐标</div>
          <div class="coord-list">
            <div>左上：({{ selectedBoothInfo.top_left_x }}, {{ selectedBoothInfo.top_left_y }})</div>
            <div>右上：({{ selectedBoothInfo.top_right_x }}, {{ selectedBoothInfo.top_right_y }})</div>
            <div>右下：({{ selectedBoothInfo.bottom_right_x }}, {{ selectedBoothInfo.bottom_right_y }})</div>
            <div>左下：({{ selectedBoothInfo.bottom_left_x }}, {{ selectedBoothInfo.bottom_left_y }})</div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeBoothInfoDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="editSelectedBooth"
          v-if="selectedBoothInfo"
        >
          编辑此展位
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import seatMap from '@/assets/upload/seat_map.webp';
import moment from 'moment';

export default {
  data() {
    return {
      map_url:'',
      scheduleData: null,
      schedule_id: '',
      expo_id:'',
      activeTab: 'list',
      currentBooth: {
        id: '',
        name: '',
        hall_id: '',
        category_id: '',
        type: 1,
        price: 0,
        area: 0,
        top_left_x: 0,
        top_left_y: 0,
        top_right_x: 0,
        top_right_y: 0,
        bottom_right_x: 0,
        bottom_right_y: 0,
        bottom_left_x: 0,
        bottom_left_y: 0,
        image_url: '',
        description: ''
      },
      rules: {
        name: [{ required: true, message: '请输入展位名称', trigger: 'blur' }],
        hall_id: [{ required: true, message: '请选择展馆', trigger: 'change' }],
        category_id: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        area: [{ required: true, message: '请输入面积', trigger: 'blur' }]
      },
      hallList: [
        { id: 1, name: 'A展馆', map_url: seatMap },
        { id: 2, name: 'B展馆', map_url: seatMap },
        { id: 3, name: 'C展馆', map_url: seatMap }
      ],
      categoryList: [
        { id: 1, name: '标准展位' },
        { id: 2, name: '特装展位' },
        { id: 3, name: '室外展位' }
      ],
      boothList: [],
      isSelectingPoints: false,
      selectedPoints: [],
      mousePosition: null,
      canvas: null,
      ctx: null,
      backgroundImage: null,
      canvasWidth: 800,
      canvasHeight: 600,
      scale: 1,
      offsetX: 0,
      offsetY: 0,
      isDragging: false,
      lastMouseX: 0,
      lastMouseY: 0,
      savedBoothElements: [],
      isLocked: false,
      showBoothInfoDialog: false,
      selectedBoothInfo: null,
      highlightedBooth: null
    };
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return '-';
      return moment(add_time * 1000).format('YYYY-MM-DD HH:mm');
    }
  },
  created() {
    
    if (this.schedule_id) {
      this.getScheduleDetail();
    } else {
      // this.$message.error('展会排期ID不存在');
      // this.goBack();
    }
  },
  mounted() {

    this.schedule_id = this.$route.query.id;
    this.expo_id = this.$route.query.expo_id;
    this.getExpoOne();

    
  },
  beforeDestroy() {
    if (this.$refs.mapCanvas) {
      this.$refs.mapCanvas.removeEventListener('wheel', this.handleWheel);
    }
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  },
  methods: {
    async getExpoOne(){
       const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        id: this.expo_id
      };
      let res=  await this.$axios.findExpoOne(param);
      if(res.code==200){
          let file_list=res.data.expo_file;

          const item = file_list.find((h) => h.type ===1);
          if (item && item.file_url){
              this.map_url=item.file_url;//展会平面图


              this.initCanvas();
    this.loadBooths();
    this.$nextTick(() => {
      this.loadHallMap();
     });

          }

          console.log(file_list);
      }
    },
    getScheduleDetail() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        id: this.schedule_id
      };
      this.$axios
        .findExpoScheduleOne(param)
        .then((res) => {
          if (res.code == 200) {
            this.scheduleData = res.data || {};
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    initCanvas() {
      this.canvas = this.$refs.canvas;
      this.ctx = this.canvas.getContext('2d');
      if (this.$refs.mapCanvas) {
        this.$refs.mapCanvas.addEventListener('wheel', this.handleWheel, {
          passive: false
        });
      }
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    },
    getDefaultMapImage() {
      return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjlmOWY5Ii8+PGcgc3Ryb2tlPSIjZTBkMGQwIiBzdHJva2Utd2lkdGg9IjAuNSI+PHBhdGggZD0iTSAwIDAgTCAwIDYwMCBNIDIwIDAgTCAyMCA2MDAgTTQwIDAgTCA0MCA2MDAgTTYwIDAgTCA2MCA2MDAgTTgwIDAgTCA4MCA2MDAgTTEwMCAwIEwgMTAwIDYwME0xMjAgMCBMMTIwIDYwME0xNDAgMCBMMTQwIDYwME0xNjAgMCBMMTYwIDYwME0xODAgMCBMMTgwIDYwME0yMDAgMCBMMjAwIDYwME0yMjAgMCBMMjIwIDYwME0yNDAgMCBMMjQwIDYwME0yNjAgMCBMMjYwIDYwME0yODAgMCBMMjgwIDYwME0zMDAgMCBMMzAwIDYwME0zMjAgMCBMMzIwIDYwME0zNDAgMCBMMzQwIDYwME0zNjAgMCBMMzYwIDYwME0zODAgMCBMMzgwIDYwME00MDAgMCBMMDQwIDYwME00MjAgMCBMMDQyIDYwME00NDAgMCBMMDQ0IDYwME00NjAgMCBMMDQ2IDYwME00ODAgMCBMMDQ4IDYwME01MDAgMCBMMDUwIDYwME01MjAgMCBMMDUyIDYwME01NDAgMCBMMDU0IDYwME01NjAgMCBMMDU2IDYwME01ODAgMCBMMDU4IDYwME02MDAgMCBMMDYwIDYwME02MjAgMCBMMDYyIDYwME02NDAgMCBMMDY0IDYwME02NjAgMCBMMDY2IDYwME02ODAgMCBMMDY4IDYwME03MDAgMCBMMDcwIDYwME03MjAgMCBMMDcyIDYwME03NDAgMCBMMDc0IDYwME03NjAgMCBMMDc2IDYwME03ODAgMCBMMDc4IDYwME04MDAgMCBMMDgwIDYwMCIvPjxwYXRoIGQ9Ik0wIDAgTDgwMCAwIE0wIDIwIEw4MDAgMjBNMCA0MCBMODAwIDQwTTAgNjAgTDgwMCA2ME0wIDgwIEw4MDAgODBNMCAxMDAgTDgwMCAxMDBNMCAxMjAgTDgwMCAxMjBNMCAxNDAgTDgwMCAxNDBNMCAxNjAgTDgwMCAxNjBNMCAxODAgTDgwMCAxODBNMCAyMDAgTDgwMCAyMDBNMCAyMjAgTDgwMCAyMjBNMCAyNDAgTDgwMCAyNDBNMCAyNjAgTDgwMCAyNjBNMCAyODAgTDgwMCAyODBNMCAzMDAgTDgwMCAzMDBNMCAzMjAgTDgwMCAzMjBNMCAzNDAgTDgwMCAzNDBNMCAzNjAgTDgwMCAzNjBNMCAzODAgTDgwMCAzODBNMCA0MDAgTDgwMCA0MDBNMCA0MjAgTDgwMCA0MjBNMCA0NDAgTDgwMCA0NDBNMCA0NjAgTDgwMCA0NjBNMCA0ODAgTDgwMCA0ODBNMCA1MDAgTDgwMCA1MDBNMCA1MjAgTDgwMCA1MjBNMCA1NDAgTDgwMCA1NDBNMCA1NjAgTDgwMCA1NjBNMCA1ODAgTDgwMCA1ODBNMCA2MDAgTDgwMCA2MDAiLz48L2c+PGcgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjEiPjxwYXRoIGQ9Ik0wIDAgTDgwMCAwIE0wIDAgTDAgNjAwIi8+PC9nPjwvc3ZnPg==';
    },
    async loadHallMap() {
      try {
        // const hall =
        //   this.hallList.find((h) => h.id === this.currentBooth.hall_id) ||
        //   this.hallList[0];
        // if (hall && hall.map_url) {
        //   await this.loadImage(hall.map_url);
        // } else {
        //   this.drawGridBackground();
        // }
        
         
        if (this.map_url) {
          await this.loadImage(this.map_url);
        } else {
          this.drawGridBackground();
        }
      } catch (error) {
        console.error('加载地图失败:', error);
        this.drawGridBackground();
      }
    },
    loadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const timeout = setTimeout(() => {
          reject(new Error('图片加载超时'));
        }, 5000);
        img.onload = () => {
          clearTimeout(timeout);
          this.backgroundImage = img;
          this.adjustCanvasSize();
          this.drawMap();
          this.drawAllSavedBooths();
          resolve();
        };
        img.onerror = (error) => {
          clearTimeout(timeout);
          console.error('图片加载失败:', error);
          this.loadDefaultImage();
          reject(error);
        };
        img.src = src;
        if (img.complete) {
          img.onload();
        }
      });
    },
    loadDefaultImage() {
      const defaultImg = new Image();
      defaultImg.onload = () => {
        this.backgroundImage = defaultImg;
        this.drawMap();
        this.drawAllSavedBooths();
      };
      defaultImg.src = this.getDefaultMapImage();
    },
    adjustCanvasSize() {
      if (this.backgroundImage && this.backgroundImage.width) {
        const maxWidth = 800;
        const maxHeight = 600;
        let width = this.backgroundImage.width;
        let height = this.backgroundImage.height;
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = width * ratio;
          height = height * ratio;
        }
        this.canvasWidth = Math.floor(width);
        this.canvasHeight = Math.floor(height);
        this.canvas.width = this.canvasWidth;
        this.canvas.height = this.canvasHeight;
      }
    },
    drawAllSavedBooths() {
      this.clearSavedBooths();
      this.boothList.forEach((booth) => {
        this.drawSavedBooth(booth);
      });
    },
    drawSavedBooth(booth) {
      const polygon = document.createElement('div');
      polygon.className = 'saved-booth-polygon';
      polygon.style.position = 'absolute';
      polygon.style.border = '2px solid #409eff';
      polygon.style.backgroundColor = 'rgba(64, 158, 255, 0.2)';
      polygon.style.zIndex = '10';
      const points = [
        { x: booth.top_left_x, y: booth.top_left_y },
        { x: booth.top_right_x, y: booth.top_right_y },
        { x: booth.bottom_right_x, y: booth.bottom_right_y },
        { x: booth.bottom_left_x, y: booth.bottom_left_y }
      ];
      const minX = Math.min(...points.map((p) => p.x));
      const minY = Math.min(...points.map((p) => p.y));
      const maxX = Math.max(...points.map((p) => p.x));
      const maxY = Math.max(...points.map((p) => p.y));
      polygon.style.left = minX * this.scale + this.offsetX + 'px';
      polygon.style.top = minY * this.scale + this.offsetY + 'px';
      polygon.style.width = (maxX - minX) * this.scale + 'px';
      polygon.style.height = (maxY - minY) * this.scale + 'px';
      const clipPath = `polygon(${
        (booth.top_left_x - minX) * this.scale
      }px ${(booth.top_left_y - minY) * this.scale}px,${
        (booth.top_right_x - minX) * this.scale
      }px ${(booth.top_right_y - minY) * this.scale}px,${
        (booth.bottom_right_x - minX) * this.scale
      }px ${(booth.bottom_right_y - minY) * this.scale}px,${
        (booth.bottom_left_x - minX) * this.scale
      }px ${(booth.bottom_left_y - minY) * this.scale}px)`;
      polygon.style.clipPath = clipPath;
      polygon.style.webkitClipPath = clipPath;
      const label = document.createElement('div');
      label.className = 'booth-label';
      label.textContent = booth.name;
      label.style.position = 'absolute';
      label.style.left = '50%';
      label.style.top = '50%';
      label.style.transform = 'translate(-50%, -50%)';
      label.style.background = 'rgba(255, 107, 107, 0.8)';
      label.style.padding = '2px 6px';
      label.style.borderRadius = '2px';
      label.style.fontSize = '12px';
      label.style.fontWeight = 'bold';
      label.style.zIndex = '11';
      polygon.appendChild(label);
      this.$refs.mapCanvas.appendChild(polygon);
      this.savedBoothElements.push(polygon);
    },
    clearSavedBooths() {
      this.savedBoothElements.forEach((element) => {
        if (element && element.parentNode) {
          element.parentNode.removeChild(element);
        }
      });
      this.savedBoothElements = [];
    },
    drawSelectedPoints() {
      const ctx = this.ctx;
      this.selectedPoints.forEach((point, index) => {
        ctx.save();
        ctx.translate(this.offsetX, this.offsetY);
        ctx.scale(this.scale, this.scale);
        ctx.fillStyle = '#f56c6c';
        ctx.beginPath();
        ctx.arc(point.x, point.y, 5 / this.scale, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#fff';
        ctx.font = `${10 / this.scale}px Arial`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText((index + 1).toString(), point.x, point.y);
        ctx.restore();
      });
    },
    drawGridBackground() {
      const ctx = this.ctx;
      const width = this.canvas.width;
      const height = this.canvas.height;
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = '#f9f9f9';
      ctx.fillRect(0, 0, width, height);
      ctx.strokeStyle = '#e0e0e0';
      ctx.lineWidth = 0.5;
      for (let x = 0; x <= width; x += 20) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height);
        ctx.stroke();
      }
      for (let y = 0; y <= height; y += 20) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(width, y);
        ctx.stroke();
      }
      ctx.strokeStyle = '#999';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(width, 0);
      ctx.moveTo(0, 0);
      ctx.lineTo(0, height);
      ctx.stroke();
      ctx.fillStyle = '#666';
      ctx.font = '10px Arial';
      for (let x = 50; x <= width; x += 50) {
        ctx.fillText(x, x, 10);
      }
      for (let y = 50; y <= height; y += 50) {
        ctx.fillText(y, 5, y);
      }
    },
    handleMapClick(event) {
      const rect = this.canvas.getBoundingClientRect();
      const x = (event.clientX - rect.left - this.offsetX) / this.scale;
      const y = (event.clientY - rect.top - this.offsetY) / this.scale;
      const clickPoint = { x: Math.round(x), y: Math.round(y) };
      if (this.isSelectingPoints) {
        this.selectedPoints.push(clickPoint);
        if (this.selectedPoints.length === 4) {
          this.setBoothCoordinates();
          this.isSelectingPoints = false;
          this.$message.success('已选择四个点，坐标已自动填充');
        }
        this.drawMap();
      } else {
        this.checkBoothClick(clickPoint);
      }
    },
    handleMouseDown(event) {
      if (event.button === 0) {
        this.isDragging = true;
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
        event.preventDefault();
      }
    },
    handleMouseMove(event) {
      const rect = this.canvas.getBoundingClientRect();
      const x = (event.clientX - rect.left - this.offsetX) / this.scale;
      const y = (event.clientY - rect.top - this.offsetY) / this.scale;
      this.mousePosition = { x: Math.round(x), y: Math.round(y) };
      if (this.isDragging) {
        this.offsetX += event.clientX - this.lastMouseX;
        this.offsetY += event.clientY - this.lastMouseY;
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
        this.drawMap();
        this.updateSavedBoothsPosition();
      }
    },
    handleMouseUp(event) {
      if (event.button === 0) {
        this.isDragging = false;
      }
    },
    handleWheel(event) {
      if (this.isLocked) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      if (!this.$refs.mapCanvas) return;
      const rect = this.canvas.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      const zoomIntensity = 0.1;
      const wheel = event.deltaY < 0 ? 1 : -1;
      const zoom = Math.exp(wheel * zoomIntensity);
      const newScale = this.scale * zoom;
      this.scale = Math.max(0.1, Math.min(5, newScale));
      this.offsetX -= (mouseX - this.offsetX) * (zoom - 1);
      this.offsetY -= (mouseY - this.offsetY) * (zoom - 1);
      this.drawMap();
      this.updateSavedBoothsPosition();
    },
    checkBoothClick(clickPoint) {
      for (let i = this.boothList.length - 1; i >= 0; i--) {
        const booth = this.boothList[i];
        if (this.isPointInPolygon(clickPoint, this.getBoothPolygon(booth))) {
          this.showBoothInfo(booth);
          return;
        }
      }
      this.clearBoothHighlight();
    },
    isPointInPolygon(point, polygon) {
      const x = point.x,
        y = point.y;
      let inside = false;
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].x,
          yi = polygon[i].y;
        const xj = polygon[j].x,
          yj = polygon[j].y;
        const intersect =
          yi > y != yj > y &&
          x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }
      return inside;
    },
    getBoothPolygon(booth) {
      return [
        { x: booth.top_left_x, y: booth.top_left_y },
        { x: booth.top_right_x, y: booth.top_right_y },
        { x: booth.bottom_right_x, y: booth.bottom_right_y },
        { x: booth.bottom_left_x, y: booth.bottom_left_y }
      ];
    },
    showBoothInfo(booth) {
      this.selectedBoothInfo = booth;
      this.showBoothInfoDialog = true;
      this.highlightBooth(booth);
    },
    highlightBooth(booth) {
      this.clearBoothHighlight();
      const highlight = document.createElement('div');
      highlight.className = 'booth-highlight';
      highlight.dataset.boothId = booth.id;
      highlight.style.position = 'absolute';
      highlight.style.border = '3px solid #ff6b6b';
      highlight.style.backgroundColor = 'rgba(255, 107, 107, 0.3)';
      highlight.style.zIndex = '20';
      highlight.style.pointerEvents = 'none';
      const points = this.getBoothPolygon(booth);
      const minX = Math.min(...points.map((p) => p.x));
      const minY = Math.min(...points.map((p) => p.y));
      const maxX = Math.max(...points.map((p) => p.x));
      const maxY = Math.max(...points.map((p) => p.y));
      highlight.style.left = minX * this.scale + this.offsetX + 'px';
      highlight.style.top = minY * this.scale + this.offsetY + 'px';
      highlight.style.width = (maxX - minX) * this.scale + 'px';
      highlight.style.height = (maxY - minY) * this.scale + 'px';
      const clipPath = `polygon(${
        (booth.top_left_x - minX) * this.scale
      }px ${(booth.top_left_y - minY) * this.scale}px,${
        (booth.top_right_x - minX) * this.scale
      }px ${(booth.top_right_y - minY) * this.scale}px,${
        (booth.bottom_right_x - minX) * this.scale
      }px ${(booth.bottom_right_y - minY) * this.scale}px,${
        (booth.bottom_left_x - minX) * this.scale
      }px ${(booth.bottom_left_y - minY) * this.scale}px)`;
      highlight.style.clipPath = clipPath;
      highlight.style.webkitClipPath = clipPath;
      this.$refs.mapCanvas.appendChild(highlight);
      this.highlightedBooth = highlight;
    },
    clearBoothHighlight() {
      if (this.highlightedBooth && this.highlightedBooth.parentNode) {
        this.highlightedBooth.parentNode.removeChild(this.highlightedBooth);
        this.highlightedBooth = null;
      }
    },
    closeBoothInfoDialog() {
      this.showBoothInfoDialog = false;
      this.selectedBoothInfo = null;
      this.clearBoothHighlight();
    },
    editSelectedBooth() {
      if (this.selectedBoothInfo) {
        this.editBooth(this.selectedBoothInfo);
        this.closeBoothInfoDialog();
      }
    },
    drawMap() {
      if (!this.ctx) return;
      const ctx = this.ctx;
      const width = this.canvas.width;
      const height = this.canvas.height;
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = '#f9f9f9';
      ctx.fillRect(0, 0, width, height);
      ctx.save();
      ctx.translate(this.offsetX, this.offsetY);
      ctx.scale(this.scale, this.scale);
      if (this.backgroundImage && this.backgroundImage.width > 0) {
        try {
          ctx.drawImage(this.backgroundImage, 0, 0);
        } catch (error) {
          console.error('绘制图片失败:', error);
          this.drawGridBackground();
        }
      } else {
        this.drawGridBackground();
      }
      ctx.restore();
      this.drawSelectedPoints();
    },
    updateSavedBoothsPosition() {
      this.drawAllSavedBooths();
      if (this.selectedBoothInfo) {
        this.highlightBooth(this.selectedBoothInfo);
      }
    },
    setBoothCoordinates() {
      if (this.selectedPoints.length === 4) {
        const sortedPoints = this.selectedPoints.sort((a, b) => {
          if (a.y === b.y) return a.x - b.x;
          return a.y - b.y;
        });
        const topPoints = sortedPoints.slice(0, 2).sort((a, b) => a.x - b.x);
        const bottomPoints = sortedPoints.slice(2, 4).sort((a, b) => a.x - b.x);
        this.currentBooth.top_left_x = topPoints[0].x;
        this.currentBooth.top_left_y = topPoints[0].y;
        this.currentBooth.top_right_x = topPoints[1].x;
        this.currentBooth.top_right_y = topPoints[1].y;
        this.currentBooth.bottom_right_x = bottomPoints[1].x;
        this.currentBooth.bottom_right_y = bottomPoints[1].y;
        this.currentBooth.bottom_left_x = bottomPoints[0].x;
        this.currentBooth.bottom_left_y = bottomPoints[0].y;
      }
    },
    startPointSelection() {
      this.isSelectingPoints = !this.isSelectingPoints;
      this.selectedPoints = [];
      if (this.isSelectingPoints) {
        this.$message.info('请在图上点击选择四个角点');
      } else {
        this.$message.info('已退出选点模式');
      }
    },
    clearCoordinates() {
      this.selectedPoints = [];
      this.currentBooth.top_left_x = 0;
      this.currentBooth.top_left_y = 0;
      this.currentBooth.top_right_x = 0;
      this.currentBooth.top_right_y = 0;
      this.currentBooth.bottom_right_x = 0;
      this.currentBooth.bottom_right_y = 0;
      this.currentBooth.bottom_left_x = 0;
      this.currentBooth.bottom_left_y = 0;
      this.drawMap();
      this.$message.info('已清空坐标');
    },
    updatePositionDisplay() {
      this.drawMap();
    },
    zoomIn() {
      if (this.isLocked) {
        this.$message.warning('视图已锁定，无法缩放');
        return;
      }
      this.scale *= 1.2;
      this.scale = Math.min(5, this.scale);
      this.drawMap();
      this.updateSavedBoothsPosition();
    },
    zoomOut() {
      if (this.isLocked) {
        this.$message.warning('视图已锁定，无法缩放');
        return;
      }
      this.scale /= 1.2;
      this.scale = Math.max(0.1, this.scale);
      this.drawMap();
      this.updateSavedBoothsPosition();
    },
    resetView() {
      this.scale = 1;
      this.offsetX = 0;
      this.offsetY = 0;
      this.drawMap();
      this.updateSavedBoothsPosition();
      this.$message.success('视图已重置');
    },
    toggleLock() {
      this.isLocked = !this.isLocked;
      if (this.isLocked) {
        this.$message.success('视图已锁定，可拖拽但无法缩放');
      } else {
        this.$message.info('视图已解锁，可缩放和拖拽');
      }
    },
    autoDetectBooths() {
      this.$message.info('自动识别功能开发中...');
    },
    beforeMapUpload(file) {
      const isImage = /\.(png|jpg|jpeg|webp|svg)$/i.test(file.name);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    handleMapUpload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.backgroundImage = new Image();
        this.backgroundImage.onload = () => {
          this.adjustCanvasSize();
          this.drawMap();
          this.drawAllSavedBooths();
          this.$message.success('地图上传成功');
        };
        this.backgroundImage.onerror = () => {
          this.$message.error('图片加载失败');
          this.drawGridBackground();
        };
        this.backgroundImage.src = e.target.result;
      };
      reader.readAsDataURL(file.raw);
    },
    handleHallChange(hallId) {
      console.log(hallId);
      this.loadHallMap();
    },
    handleImageUpload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.currentBooth.image_url = e.target.result;
      };
      reader.readAsDataURL(file.raw);
    },
    loadBooths() {
      this.boothList = [];
      const params1 = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        expo_id:this.expo_id
      };
      this.$axios.findBoothList(params1).then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            let it = {
              id: item.id,
              name: item.sn,
              expo_title: item.expo ? item.expo.title : '',
              venue_title: item.venue ? item.venue.title : '',
              order_shop_title: item.ordershop ? item.ordershop.name : '',
              order_time: item.order_time,
              hall_id: 1,
              hall_name: 'A展馆',
              category_id: 1,
              category_name: '标准展位',
              type: item.type,
              price: 5000,
              area: item.area,
                 amount: item.amount,
              top_left_x: item.x1,
              top_left_y: item.y1,
              top_right_x: item.x2,
              top_right_y: item.y2,
              bottom_right_x: item.x3,
              bottom_right_y: item.y3,
              bottom_left_x: item.x4,
              bottom_left_y: item.y4,
              image_url: '',
              description: '位于A展馆入口处的标准展位'
            };
            this.boothList.push(it);
          });
        }
      });
    },
    addNewBooth() {
      this.currentBooth = {
        id: '',
        name: '',
        hall_id: this.hallList[0].id,
        category_id: this.categoryList[0].id,
        type: 1,
        price: 0,
        area: 0,
        amount:0,
        top_left_x: 0,
        top_left_y: 0,
        top_right_x: 0,
        top_right_y: 0,
        bottom_right_x: 0,
        bottom_right_y: 0,
        bottom_left_x: 0,
        bottom_left_y: 0,
        image_url: '',
        description: ''
      };
      this.selectedPoints = [];
      this.activeTab = 'edit';
      this.loadHallMap();
    },
    editBooth(booth) {
      this.currentBooth = { ...booth };
      this.activeTab = 'edit';
      this.loadHallMap();
    },
    deleteBooth(id) {
      this.$confirm('确定要删除这个展位吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.boothList = this.boothList.filter((booth) => booth.id !== id);
        this.drawAllSavedBooths();
        this.$message.success('删除成功');
      });
    },
    submitForm() {//保存展位信息
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (!this.validateCoordinates()) {
            this.$message.error('请设置完整的展位坐标');
            return;
          }

          if (this.currentBooth.id) {
            const index = this.boothList.findIndex(
              (b) => b.id === this.currentBooth.id
            );
            if (index !== -1) {
              this.boothList[index] = { ...this.currentBooth };
            }
          } else {
            this.currentBooth.id = Date.now();
            this.currentBooth.hall_name = this.hallList.find(
              (h) => h.id === this.currentBooth.hall_id
            )?.name;
            this.currentBooth.category_name = this.categoryList.find(
              (c) => c.id === this.currentBooth.category_id
            )?.name;
            this.boothList.push({ ...this.currentBooth });
          }
          this.$message.success('保存成功');
          const params = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            proxy_id:sessionStorage.getItem('proxy_id'),
            expo_id:this.expo_id,
            ...this.currentBooth
          };
          this.$axios.boothSave(params).then((res) => {
            if (res.code == 200) {
              console.log('保存成功');
            }
          });
          this.drawAllSavedBooths();
        }
      });
    },
    validateCoordinates() {
      return (
        this.currentBooth.top_left_x > 0 &&
        this.currentBooth.top_left_y > 0 &&
        this.currentBooth.top_right_x > 0 &&
        this.currentBooth.top_right_y > 0 &&
        this.currentBooth.bottom_right_x > 0 &&
        this.currentBooth.bottom_right_y > 0 &&
        this.currentBooth.bottom_left_x > 0 &&
        this.currentBooth.bottom_left_y > 0
      );
    },
    resetForm() {
      this.$refs.formRef.resetFields();
      this.clearCoordinates();
    },
    exportBooths() {
      const dataStr = JSON.stringify(this.boothList, null, 2);
      const dataBlob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'booths_export.json';
      link.click();
      URL.revokeObjectURL(url);
      this.$message.success('导出成功');
    },
    handleTabClick(tab) {
      if (tab.name === 'list') {
        this.loadBooths();
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
/* 全局页面容器 */
.booth-page-container {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 80px);
}

/* 卡片样式 */
.box-card {
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  border: none;
}

/* 标签页美化 */
.custom-tabs {
  --el-tabs-active-tab-color: #1677ff;
  --el-tabs-card-border-color: #e4e7ed;
}

/* 表格工具栏 */
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px 12px;
  background: #fafbfc;
  border-radius: 6px;
}

.left-group {
  display: flex;
  gap: 10px;
}

.right-group .stats-info {
  color: #666;
  font-size: 13px;
  padding: 0 10px;
}

/* 表格头部 */
.table-header {
  background-color: #fafbfc !important;
  color: #333;
  font-weight: 500;
}

/* 状态标签 */
.status-tag {
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 500;
}

.status-tag.yes {
  color: #00b42a;
  background: #e6ffed;
}

.status-tag.no {
  color: #ff4d4f;
  background: #fff2f0;
}

.pay-info {
  color: #1677ff;
  font-size: 12px;
  font-weight: 500;
}

.price-text {
  color: #ff4d4f;
  font-weight: 500;
}

/* 表单样式 支付宝风格 */
.form-wrapper {
  padding: 10px;
}

.ali-pay-form {
  max-width: 100%;
}

.form-section {
  background: #fafbfc;
  border-radius: 8px;
  padding: 18px 20px;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
}

.section-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.section-title i {
  color: #1677ff;
}

.input-style,
.select-style {
  width: 100%;
  border-radius: 6px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.number-style {
  width: 100%;
  border-radius: 6px;
}

.textarea-style {
  border-radius: 6px;
}

/* 布局容器 */
.layout-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.form-container {
  flex: 1;
  min-width: 380px;
  max-width: 420px;
}

.map-container {
  flex: 2;
  min-width: 500px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 15px;
  background-color: #fff;
  position: relative;
}

.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.map-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.map-controls {
  display: flex;
  gap: 6px;
  align-items: center;
}

.map-canvas {
  width: 100%;
  height: 420px;
  background: #fff;
  border: 1px solid #dcdfe6;
  position: relative;
  cursor: crosshair;
  overflow: hidden;
  border-radius: 4px;
}

.coordinates-display {
  margin-top: 12px;
  padding: 10px 12px;
  background: #f0f9ff;
  border-radius: 4px;
  font-size: 12px;
}

.coordinate-item {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.zoom-display {
  margin-left: 8px;
  padding: 3px 8px;
  background: rgba(22, 119, 255, 0.1);
  border-radius: 4px;
  font-size: 12px;
  color: #1677ff;
  font-weight: 500;
}

/* 按钮组 */
.tool-buttons {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.upload-btn {
  display: inline-block;
}

/* 图片预览 */
.image-preview {
  margin-top: 10px;
  width: 180px;
  height: 120px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.tip-text {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

/* 表单按钮 */
.form-button-group {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

/* 弹窗样式 */
.info-dialog {
  --el-dialog-header-font-size: 15px;
}

.dialog-body {
  padding: 10px 0;
}

.dialog-price {
  color: #ff4d4f;
  font-weight: 500;
}

.coord-box {
  margin-top: 15px;
  background: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
}

.coord-title {
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.coord-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  font-size: 12px;
  color: #666;
}

.dialog-footer {
  text-align: right;
}

/* 已保存展位样式 */
.saved-booth-polygon {
  pointer-events: none;
}

.booth-label {
  pointer-events: none;
}
</style>